import { z } from "zod";
const accountIdSchema = z.uuid().brand();
function asAccountId(id) {
  return accountIdSchema.parse(id);
}
const placeholderAccountName = "___Placeholder Account___";
export {
  accountIdSchema,
  asAccountId,
  placeholderAccountName
};
//# sourceMappingURL=account.js.map
